import { render, staticRenderFns } from "./activity-form-number-scale-preview.vue?vue&type=template&id=45c4d4b9&scoped=true&"
import script from "./activity-form-number-scale-preview.vue?vue&type=script&lang=js&"
export * from "./activity-form-number-scale-preview.vue?vue&type=script&lang=js&"
import style0 from "./activity-form-number-scale-preview.vue?vue&type=style&index=0&id=45c4d4b9&scoped=true&lang=scss&"
import style1 from "./activity-form-number-scale-preview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c4d4b9",
  null
  
)

component.options.__file = "activity-form-number-scale-preview.vue"
export default component.exports